import { admessageConstants } from '../constants';
import { admessageService } from '../services';
import { showToast } from '../services/toast';

export const admessageActions = {
    fetchAdMessages,
    createAdMessage,
    updateAdMessage,
    deleteAdMessage
};

function fetchAdMessages() {
    return dispatch => {
        dispatch(request());

        admessageService.fetchAdMessages()
            .then(
                response => {
                    dispatch(success(response.data));
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: admessageConstants.FETCH_ADMESSAGES_REQUEST } }
    function success(admessages) { return { type: admessageConstants.FETCH_ADMESSAGES_SUCCESS, admessages } }
    function failure(error) { return { type: admessageConstants.FETCH_ADMESSAGES_FAILURE, error } }
}

function createAdMessage(admessageDetails) {
    return dispatch => {
        dispatch(request());

        return admessageService.createAdMessage(admessageDetails)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: admessageConstants.CREATE_ADMESSAGE_REQUEST } }
    function success(admessages) { return { type: admessageConstants.CREATE_ADMESSAGE_SUCCESS, admessages } }
    function failure(error) { return { type: admessageConstants.CREATE_ADMESSAGE_FAILURE, error } }
}

function updateAdMessage(admessageDetails) {

    return dispatch => {
        dispatch(request());

        return admessageService.updateAdMessage(admessageDetails)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: admessageConstants.UPDATE_ADMESSAGE_REQUEST } }
    function success(admessages) { return { type: admessageConstants.UPDATE_ADMESSAGE_SUCCESS, admessages } }
    function failure(error) { return { type: admessageConstants.UPDATE_ADMESSAGE_FAILURE, error } }

}

function deleteAdMessage(popupId) {

    return dispatch => {
        dispatch(request());
        
        return admessageService.deleteAdMessage(popupId)
            .then(
                (response) => {
                    dispatch(success(popupId));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: admessageConstants.DELETE_ADMESSAGE_REQUEST } }
    function success(id) { return { type: admessageConstants.DELETE_ADMESSAGE_SUCCESS, payload: id } }
    function failure(error) { return { type: admessageConstants.DELETE_ADMESSAGE_FAILURE, error } }
}